// Module
var code = `<span data-bind="class: className">
    <span class="svc-string-editor__content">
        <div class="svc-string-editor__border svc-string-editor__border--hover"></div>
        <div class="svc-string-editor__border svc-string-editor__border--focus"></div>
        <span class="svc-string-editor__input">
            <!-- ko ifnot: koHasHtml -->
            <!-- ko template: {afterRender: afterRender} -->
            <span role="textbox" class="sv-string-editor" spellcheck="false" data-bind="text: koRenderedHtml, event: { focus: onFocus, paste: onPaste, blur: onBlur, input: onInput, keydown: onKeyDown, keyup: onKeyUp, mouseup: onMouseUp, compositionstart: onCompositionStart, compositionend: onCompositionEnd }, click: edit, attr: { 'aria-placeholder': placeholder, 'aria-label': this.placeholder || 'content editable', contenteditable: contentEditable }"></span>
            <!-- /ko -->
            <!-- /ko -->
            <!-- ko if: koHasHtml -->
            <span role="textbox" class="sv-string-editor sv-string-editor--html" spellcheck="false" data-bind="html: koRenderedHtml, event: { focus: onFocus, blur: onBlur, keydown: onKeyDown, keyup: onKeyUp, mouseup: onMouseUp, compositionstart: onCompositionStart, compositionend: onCompositionEnd }, click: edit, attr: { 'aria-placeholder': placeholder, 'aria-label': this.placeholder || 'content editable', contenteditable: contentEditable }"></span>
            <!-- /ko -->
            <!-- ko if: showCharacterCounter -->
            <!-- ko component: { name: 'sv-character-counter', params: { counter: characterCounter, remainingCharacterCounter: getCharacterCounterClass } } -->
            <!-- /ko -->
            <!-- /ko -->
        </span>
    </span>
    <!-- ko if: errorText -->
    <span class="svc-string-editor__error" data-bind="text: errorText"></span>
    <!-- /ko -->
</span>`;
// Exports
export default code;